export enum BasisEnum {
  ACCRUAL = 'Accrual',
  CASH = 'Cash',
  OTHER = 'Other',
}
